import React from "react";
import { Edit, SimpleForm } from 'react-admin';

import { SaveWithCancelWithPasswordChangeToolbar } from '../../../components/toolbars/SaveWithCancelWithPasswordChangeToolbar';
import { DeveloperForm } from '../forms/DeveloperForm';


export const DeveloperEdit = (props) => (
	<Edit {...props} undoable={false}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelWithPasswordChangeToolbar />}>
			<DeveloperForm />
		</SimpleForm>
	</Edit>
);
